package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.PreMadeCharacter
import fr.manyverse.app.domain.repository.ImageStorageRepository
import fr.manyverse.app.domain.repository.PreMadeCharacterRepository

class GetPreMadeCharactersUseCase(
    private val preMadeCharacterRepository: PreMadeCharacterRepository,
    private val imageStorageRepository: ImageStorageRepository
) {
    suspend operator fun invoke(tableId: String): Result<List<PreMadeCharacter>> {
        return preMadeCharacterRepository.getPreMadeCharactersByTableId(tableId)
            .map { preMades ->
                preMades.map { preMade ->
                    val signedAvatar = preMade.imageUrl?.let { path ->
                        imageStorageRepository.getSignedUrl(path).getOrNull()
                    }
                    val signedInventory = preMade.inventory.map { item ->
                        val signed = item.imageUrl?.let { path ->
                            imageStorageRepository.getSignedUrl(path).getOrNull()
                        }
                        if (signed != null) item.copy(signedImageUrl = signed) else item
                    }
                    preMade.copy(
                        signedImageUrl = signedAvatar,
                        inventory = signedInventory
                    )
                }
            }
    }
}
